import React, { Component } from 'react';

import hexGeometry from './hexGeometry';

const HEX_RADIUS = 0.98;

const FIRST_COLOR = 'rgb(255, 127, 0)';
const SECOND_COLOR = 'rgb(0, 127, 255)';
const BACKGROUND_COLOR = 'rgb(30, 30, 30)';

function moveTo(ctx, point) {
  ctx.moveTo(point.x, point.y);
}

function lineTo(ctx, point) {
  ctx.lineTo(point.x, point.y);
}

function drawHex(ctx, coords, point) {
  ctx.beginPath();
  moveTo(ctx, coords.corner(point, HEX_RADIUS, 0));
  for (let i = 1; i < 6; i++) {
    lineTo(ctx, coords.corner(point, HEX_RADIUS, i));
  }
  ctx.closePath();
  ctx.fill();
}

// TODO: move this somewhere else. Also it's duplicated from lg-hex-games/extractGames
function toPoint(move) {
  const base = 'a'.codePointAt(0);
  return {x: move.codePointAt(0) - base, y: move.codePointAt(1) - base};
}

function fromPoint(point) {
  return String.fromCharCode(97 + point.x) + String.fromCharCode(97 + point.y);
}

function drawText(ctx, coords, lines) {
  // Approximation
  const lineHeight = ctx.measureText('M').width;
  for (let i = 0; i < lines.length; i++) {
    ctx.fillText(lines[i], coords.x, coords.y + 1.5 * lineHeight * (i - lines.length / 2 + 0.75));
  }
}

function mixi(r, a, b, i) {
  return Math.round((1 - r) * a[i] + r * b[i]);
}

// TODO: more correct mixing algorithm
function mix(r, a, b) {
  return 'rgb(' + mixi(r, a, b, 0) + ', ' + mixi(r, a, b, 1) + ', ' + mixi(r, a, b, 2) + ')';
}

// TODO: generalize this class
// TODO: render board rotated better
export default class HexBoard extends Component {
  constructor(props) {
    super(props);
    this.updateGeometry();
  }

  setCanvasSize() {
    const container = this.refs.container;
    const canvas = this.refs.canvas;
    const width = container.offsetWidth;
    const height = container.offsetHeight;
    this.scale = window.devicePixelRatio;
    canvas.width = width * this.scale;
    canvas.height = height * this.scale;
    canvas.getContext('2d').scale(this.scale, this.scale);
  }

  componentDidMount() {
    this.setCanvasSize();
    this.resizeListener = () => {
      this.setCanvasSize();
      this.draw();
    };
    window.addEventListener('resize', this.resizeListener);
    this.draw();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeListener);
    this.resizeListener = null;
  }

  componentDidUpdate() {
    this.updateGeometry();
    this.draw();
  }

  updateGeometry() {
    if (this.geometrySize === this.props.size) {
      return;
    }
    this.geometrySize = this.props.size;
    const points = [];
    for (let x = -1; x <= this.props.size; x++) {
      for (let y = -1; y <= this.props.size; y++) {
        if ((x >= 0 && x < this.props.size) || (y >= 0 && y < this.props.size)) {
          points.push({x, y});
        }
      }
    }
    this.geometry = hexGeometry(points);
  }

  draw() {
    console.log('draw'); // TODO: are we drawing too much?
    const canvas = this.refs.canvas;
    const ctx = canvas.getContext('2d');

    // TODO: padding as prop?
    this.coords = this.geometry(canvas.width / this.scale, canvas.height / this.scale, 0);

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = FIRST_COLOR;
    for (let x = 0; x < this.props.size; x++) {
      drawHex(ctx, this.coords, {x, y: -1});
      drawHex(ctx, this.coords, {x, y: this.props.size});
    }
    ctx.fillStyle = SECOND_COLOR;
    for (let y = 0; y < this.props.size; y++) {
      drawHex(ctx, this.coords, {x: -1, y});
      drawHex(ctx, this.coords, {x: this.props.size, y});
    }
    const drawnHexes = new Set();
    for (let i = 0; i < this.props.moves.length; i++) {
      ctx.fillStyle = (i & 1) === 0 ? FIRST_COLOR : SECOND_COLOR;
      const point = toPoint(this.props.moves[i]);
      drawnHexes.add(point.x * this.props.size + point.y);
      drawHex(ctx, this.coords, point);
    }
    let maxCount = 0;
    for (let moveData of this.props.moveData.values()) {
      maxCount = Math.max(maxCount, moveData.count);
    }
    const firstPlayer = (this.props.moves.length & 1) === 0;
    for (let [move, moveData] of this.props.moveData) {
      if (!move) {
        continue;
      }
      const point = toPoint(move);
      drawnHexes.add(point.x * this.props.size + point.y);
      // TODO: instead of using alpha, calculate the correct color (and don't draw over hexes)
      const alpha = moveData.count / maxCount;
      const c = this.coords.center(point);
      // TODO: duplicated the background color here
      ctx.fillStyle = mix(alpha, [30, 30, 30], (firstPlayer ? [255, 127, 0] : [0, 127, 255]));
      drawHex(ctx, this.coords, point);
      ctx.fillStyle = '#ffffff';
      ctx.textAlign = 'center';
      const displayData = [];
      if (isFinite(moveData.advantage.mean)) {
        ctx.font = Math.round(0.6 * this.coords.innerRadius) + 'px sans-serif';
        displayData.push(Math.round(moveData.advantage.mean * 400 / Math.log(10)));
        displayData.push('±' + Math.round(moveData.advantage.error * 400 / Math.log(10)));
      } else {
        ctx.font = Math.round(1 * this.coords.innerRadius) + 'px sans-serif';
        if (moveData.advantage.mean === Infinity) {
          displayData.push('∞');
        } else if (moveData.advantage.mean === -Infinity) {
          displayData.push('-∞');
        }
      }
      drawText(ctx, c, displayData);
    }
    ctx.fillStyle = BACKGROUND_COLOR;
    for (let x = 0; x < this.props.size; x++) {
      for (let y = 0; y < this.props.size; y++) {
        const point = {x, y};
        if (!drawnHexes.has(point.x * this.props.size + point.y)) {
          drawHex(ctx, this.coords, point);
        }
      }
    }
  }

  handleCanvasClick(event) {
    const rect = this.refs.canvas.getBoundingClientRect();
    const x = (event.clientX - rect.left);
    const y = (event.clientY - rect.top);
    const point = this.coords.hitTest({x, y});
    if (point == null) {
      return;
    }
    const move = fromPoint(point);
    if (this.props.moveData.get(move) == null) {
      return;
    }
    this.props.onMove(move);
  }

  render() {
    return (
      <div ref="container" className="boardContainer">
        <canvas ref="canvas" className="boardCanvas" onClick={(event) => this.handleCanvasClick(event)} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/HexBoard.js